import React from 'react';
import { Row, Col, Image } from '@thd-olt-component-react/core-ui';
import { EXP_ROUTES } from '../../../utils/constants';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import { generateImageSource } from '../../../utils/generateImageSource';
import GoBackNavLink from '../../../components/common/GoBackNavLink';

export const JobTemplatePageHeader = () => {
  const backToObj = {
    backTo: 'Job Postings',
    backToUrl: EXP_ROUTES.JOB_POSTINGS
  };

  return (
    <>
      <PageHeader>Path to Pro Network</PageHeader>
      <Row>
        <Col xs={12}>
          <GoBackNavLink backToStr={backToObj.backTo} fallbackUrl={backToObj.backToUrl} data-testid="job-template-list-nav-link" />
          <div className="ptp-job-template__title">
            <Image
              data-testid="jobTemplateIcon"
              alt="document icon"
              src={generateImageSource('/images/v1/path-to-pro/jobTemplateIcon.svg')}
              style={{ width: '30px', height: '30px' }}
              className="ptp-job-template__title-icon"
            />
            Job Templates
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={8} sm={8} md={6} lg={6} fallback={12} data-testid="templatePageHeaderText" className="ptp-job-template__header">
          Browse all templates below and click on each title to view details for that template. The
          job templates are meant as <b>starting points</b>. You should
          <b> always edit and change a
          template
          </b> to meet your unique job needs.
        </Col>
      </Row>
    </>
  );
};
